export default __webpack_public_path__ + "static/media/ill-pending.47c0cff8.svg";